import { render, staticRenderFns } from "./NewsletterList.vue?vue&type=template&id=507c6095"
import script from "./NewsletterList.vue?vue&type=script&lang=js"
export * from "./NewsletterList.vue?vue&type=script&lang=js"
import style0 from "./NewsletterList.vue?vue&type=style&index=0&id=507c6095&prod&lang=css"
import style1 from "./NewsletterList.vue?vue&type=style&index=1&id=507c6095&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports